// @ts-check

import { useQuery } from '@tanstack/vue-query';

import { useAuthStore } from '@/store-v2/auth';
import { checkIfUserHasSpecialRequirementInProgress } from '@/api/specialRequirements';
import { createQueryKey } from '@/composables/vue-query/util';
import { storeToRefs } from 'pinia';

export const USER_HAS_SPECIAL_REQUIREMENT_IN_PROGRESS_QUERY_KEY = createQueryKey([
  'user',
  'special-requirement',
  'in-progress',
]);

export function useUserHasSpecialRequirementInProgress() {
  const { isLoggedInUser } = storeToRefs(useAuthStore());

  if (!isLoggedInUser.value) return { userHasSpecialRequirementInProgress: false };

  // TODO: it would be great to have cache invalidation,
  // but is hard to trigger the invalidation in multiple points
  const query = useQuery({
    queryKey: USER_HAS_SPECIAL_REQUIREMENT_IN_PROGRESS_QUERY_KEY,
    queryFn: checkIfUserHasSpecialRequirementInProgress,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  return { userHasSpecialRequirementInProgress: query.data, ...query };
}

/** @typedef { import('@tanstack/vue-query').QueryClient } QueryClient */

/**
 * Invalidate the user keywords query.
 * @param {Object} options - The options object.
 * @param {QueryClient} options.queryClient - The query client instance.
 */
export const invalidateUserHasSpecialRequirementInProgress = ({ queryClient }) => {
  queryClient.invalidateQueries({ queryKey: USER_HAS_SPECIAL_REQUIREMENT_IN_PROGRESS_QUERY_KEY });
};
